module.exports = __webpack_public_path__ + "static/media/notif.a45b11e0.png";